import {Component, OnInit} from '@angular/core';
import {FtsSubject} from '../../model';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "@amlCore/utils";
import {RegistriesService} from "../../service";
import {TableService, VisitedService} from "@amlCore/services";


@Component({
  selector: 'app-registry-fts-subject',
  templateUrl: './ftsSubject.component.html'
})
export class FtsSubjectComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = false;

  constructor(private regSrv: RegistriesService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'name', dir: 'ASC'});
  }

  private id: string; // уникальный идентификатор
  public isAll = false; // поиск по всем перечням
  public ftsSubjectList: Array<FtsSubject> = [];
  public goBack = Utils.goBack;
  placeholder = 'Поиск по ФИО, наименованию, ИНН';

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id;
    if (this.id === undefined) {
      this.isAll = true;
    }
    this.activatedRoute.queryParams.subscribe((data) => {
      this.loadList(this.syncParams(data));
    });
  }

  public onPageChange(params) {
    const filter = this.getParams({...params, ...this.filter});
    filter["isAll"] = this.isAll;
    this.navigate(filter);
  }

  public onSearch() {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  private loadList(params?: any) {
    const queryParams = this.getParams(params);
    if (this.isAll) {
      this.regSrv.getFtsSubjectList(queryParams, null).subscribe(data => {
        this.ftsSubjectList = data.content;
        this.total = data.totalElements;
      });
    } else {
      this.regSrv.getFtsSubjectList(queryParams, this.id).subscribe(data => {
        this.ftsSubjectList = data.content;
        this.total = data.totalElements;
      });
    }
  }

}
